export { sendEvent } from 'next-flight-server-reference-proxy-loader?id=7fe1c27c5f29245eae4b6d52560cfcd5523d044336&name=sendEvent!'